import { MeetingChatAdapter, useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { BoardInputsWorkBox } from "../workBoxes/BoardInputsWorkBox";
import { SurveyWorkBox } from "../workBoxes/survey/SurveyWorkbox";
import { HighlightedUserListWorkBox } from "../workBoxes/list/HighlightedUserListWorkBox";
import { useSdkContext } from "../../contexts/sdk/context";
import { Chatroom } from "@kalyzee/kast-web-sdk/websocket";
import { ChatWorkBox } from "../workBoxes/ChatWorkBox";
import { ShareWorkBox } from "../workBoxes/ShareWorkBox";
import { isExpert } from "../../helpers/roles";
import React, { useRef } from "react";
import Chat, { DashboardChatRef } from "../chat/Chat";
import { useMeetingUtilsContext } from "../../contexts/meetingUtils/context";
import styles from "./CurrentWorkBox.module.css";
import clsx from "clsx";

export const CurrentWorkBox = React.memo(({
  chatInfo,
  onClose,
}: {
  chatInfo?: {
    room: Chatroom;
    adapter: MeetingChatAdapter | undefined;
  };
  onClose?: () => void;
}) => {
  const { containerAPI, populated } = useMeetingUtilsContext();
  const [session] = useMeetingSelector(containerAPI, "session");
  
  const sdkCtx = useSdkContext();
  const isMobile = useAppStoreSelector(state => state.isMobile);
  const workBoxMode = useAppStoreSelector(state => state.workBoxMode);

  const chatRef = useRef<DashboardChatRef>(null);

  const renderChatWorkBox = () => {
    if (!chatInfo) return null;
    return (
      <ChatWorkBox
        onClearMessages={isExpert(session) ? () => chatRef.current?.clearMessages() : undefined}
        onClose={onClose}
      >
        <Chat
          meetingAPI={containerAPI}
          chatroom={chatInfo.room}
          chatAdapter={chatInfo.adapter}
          ref={chatRef}
        />
      </ChatWorkBox>
    );
  };

  return (
    <div className={clsx(styles.container, { [styles.mobile]: isMobile })}>
      {workBoxMode === "inputs" && (
        <BoardInputsWorkBox
          meetingAPI={containerAPI}
          onClose={onClose}
        />
      )}
      {workBoxMode === "chat" && renderChatWorkBox()}
      {workBoxMode === "survey" && (
        <SurveyWorkBox meetingAPI={containerAPI} onClose={onClose} />
      )}
      {workBoxMode === "highlight" && (
        <HighlightedUserListWorkBox
          sdk={sdkCtx}
          highlightSessions={populated.highlighted}
          onClose={onClose}
        />
      )}
      {workBoxMode === "share" && <ShareWorkBox onClose={onClose} />}
    </div>
  );
});
